export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ZoomSliderWrapper.vue?vue&type=template&id=7c5f5a02&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/zoom/ZoomSliderWrapper.vue?vue&type=template&id=7c5f5a02&scoped=true&
// module id = 532
// module chunks = 0